import { TrendingUp, Zap, Clock, Mail, FileDown } from "lucide-react";

export function AnalyticsTab({ analyticsData }) {
  if (!analyticsData) {
    return <div className="text-center py-20 text-[#666]">Chargement...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-[#121212] border border-[#262626] rounded-2xl p-5">
          <p className="text-[#666] text-xs uppercase tracking-wider mb-1">Total Demandes</p>
          <p className="text-white font-bold text-3xl">{analyticsData.funnel.total}</p>
        </div>
        <div className="bg-[#121212] border border-[#262626] rounded-2xl p-5">
          <p className="text-[#666] text-xs uppercase tracking-wider mb-1">Taux Devis</p>
          <p className="text-[#EFFF00] font-bold text-3xl">{analyticsData.metrics.quote_rate}%</p>
        </div>
        <div className="bg-[#121212] border border-[#262626] rounded-2xl p-5">
          <p className="text-[#666] text-xs uppercase tracking-wider mb-1">Taux Conversion</p>
          <p className="text-green-400 font-bold text-3xl">{analyticsData.metrics.conversion_rate}%</p>
        </div>
        <div className="bg-[#121212] border border-[#262626] rounded-2xl p-5">
          <p className="text-[#666] text-xs uppercase tracking-wider mb-1">CA Estimé</p>
          <p className="text-white font-bold text-3xl">{analyticsData.metrics.total_revenue.toLocaleString()}€</p>
        </div>
      </div>

      <div className="bg-[#121212] border border-[#262626] rounded-2xl p-6">
        <h2 className="text-lg font-bold mb-6 flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-[#EFFF00]" />
          Funnel de Conversion
        </h2>
        <div className="space-y-3">
          {[
            { label: "Demandes reçues", value: analyticsData.funnel.total, color: "#EFFF00" },
            { label: "Relancés", value: analyticsData.funnel.relanced, color: "#3b82f6" },
            { label: "Devis envoyés", value: analyticsData.funnel.quoted, color: "#f59e0b" },
            { label: "Signés (clients)", value: analyticsData.funnel.signed, color: "#22c55e" },
            { label: "Perdus", value: analyticsData.funnel.lost, color: "#ef4444" },
          ].map((step, i) => {
            const maxVal = analyticsData.funnel.total || 1;
            const pct = Math.max(4, (step.value / maxVal) * 100);
            const rate = analyticsData.funnel.total > 0 ? Math.round(step.value / analyticsData.funnel.total * 100) : 0;
            return (
              <div key={i} className="group">
                <div className="flex items-center justify-between mb-1.5">
                  <span className="text-[#A3A3A3] text-sm">{step.label}</span>
                  <span className="text-white font-bold">{step.value} <span className="text-[#666] text-xs font-normal">({rate}%)</span></span>
                </div>
                <div className="w-full bg-[#1a1a1a] rounded-full h-8 overflow-hidden">
                  <div
                    className="h-full rounded-full transition-all duration-700 flex items-center justify-end pr-3"
                    style={{ width: `${pct}%`, backgroundColor: step.color }}
                  >
                    {pct > 15 && <span className="text-black text-xs font-bold">{step.value}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-[#121212] border border-[#262626] rounded-2xl p-6">
          <h3 className="text-md font-bold mb-4">Répartition des Statuts</h3>
          <div className="space-y-3">
            {[
              { label: "En attente", value: analyticsData.funnel.pending, color: "#666" },
              { label: "Contacté", value: analyticsData.funnel.contacted, color: "#3b82f6" },
              { label: "Devis envoyé", value: analyticsData.funnel.quoted, color: "#f59e0b" },
              { label: "Signé", value: analyticsData.funnel.signed, color: "#22c55e" },
              { label: "Perdu", value: analyticsData.funnel.lost, color: "#ef4444" },
            ].map((s, i) => (
              <div key={i} className="flex items-center justify-between bg-[#0A0A0A] rounded-lg p-3">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full" style={{backgroundColor: s.color}} />
                  <span className="text-[#A3A3A3] text-sm">{s.label}</span>
                </div>
                <span className="text-white font-bold">{s.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-[#121212] border border-[#262626] rounded-2xl p-6">
          <h3 className="text-md font-bold mb-4">Performance Automatisation</h3>
          <div className="space-y-3">
            <div className="flex items-center justify-between bg-[#0A0A0A] rounded-lg p-3">
              <span className="text-[#A3A3A3] text-sm flex items-center gap-2"><Zap className="w-4 h-4 text-[#EFFF00]" /> Analyses IA</span>
              <span className="text-white font-bold">{analyticsData.metrics.ai_analyzed}</span>
            </div>
            <div className="flex items-center justify-between bg-[#0A0A0A] rounded-lg p-3">
              <span className="text-[#A3A3A3] text-sm flex items-center gap-2"><FileDown className="w-4 h-4 text-blue-400" /> Devis générés</span>
              <span className="text-white font-bold">{analyticsData.metrics.total_quotes}</span>
            </div>
            <div className="flex items-center justify-between bg-[#0A0A0A] rounded-lg p-3">
              <span className="text-[#A3A3A3] text-sm flex items-center gap-2"><Zap className="w-4 h-4 text-green-400" /> Devis auto IA</span>
              <span className="text-white font-bold">{analyticsData.metrics.auto_quotes}</span>
            </div>
            <div className="flex items-center justify-between bg-[#0A0A0A] rounded-lg p-3">
              <span className="text-[#A3A3A3] text-sm flex items-center gap-2"><Clock className="w-4 h-4 text-blue-400" /> Taux de relance</span>
              <span className="text-white font-bold">{analyticsData.metrics.followup_rate}%</span>
            </div>
            <div className="flex items-center justify-between bg-[#0A0A0A] rounded-lg p-3">
              <span className="text-[#A3A3A3] text-sm flex items-center gap-2"><Mail className="w-4 h-4 text-purple-400" /> Abonnés newsletter</span>
              <span className="text-white font-bold">{analyticsData.metrics.newsletter_subs}</span>
            </div>
            {analyticsData.metrics.avg_deal > 0 && (
              <div className="flex items-center justify-between bg-[#0A0A0A] rounded-lg p-3 border border-green-500/20">
                <span className="text-[#A3A3A3] text-sm flex items-center gap-2"><TrendingUp className="w-4 h-4 text-green-400" /> Panier moyen</span>
                <span className="text-green-400 font-bold">{analyticsData.metrics.avg_deal.toLocaleString()}€</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {Object.keys(analyticsData.daily_leads).length > 0 && (
        <div className="bg-[#121212] border border-[#262626] rounded-2xl p-6">
          <h3 className="text-md font-bold mb-4">Activité Quotidienne (30 derniers jours)</h3>
          <div className="flex items-end gap-1 h-32">
            {(() => {
              const days = Object.entries(analyticsData.daily_leads).sort((a,b) => a[0].localeCompare(b[0]));
              const maxDay = Math.max(...days.map(d => d[1]), 1);
              return days.map(([day, count], i) => (
                <div key={i} className="flex-1 flex flex-col items-center gap-1 group" title={`${day}: ${count} demande(s)`}>
                  <span className="text-[#666] text-[9px] opacity-0 group-hover:opacity-100 transition-opacity">{count}</span>
                  <div
                    className="w-full rounded-t-sm bg-[#EFFF00] min-h-[4px] transition-all hover:bg-[#fff]"
                    style={{height: `${(count / maxDay) * 100}%`}}
                  />
                  <span className="text-[#444] text-[8px] rotate-[-45deg] origin-top-left whitespace-nowrap">
                    {day.slice(5)}
                  </span>
                </div>
              ));
            })()}
          </div>
        </div>
      )}
    </div>
  );
}
